//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import {mapGetters} from "vuex";

export default {
  name: "ScheduleCalendar",
  components: {
    EmptyScheduleCalendar: () => import("@/components/common/EmptyScheduleCalendar"),
    ScheduleCalendarScroll: () => import("@/components/common/ScheduleCalendar/ScheduleCalendarScroll"),
    ScheduleCalendarFilters: () => import("@/components/common/ScheduleCalendar/ScheduleCalendarFilters"),
    ScheduleCalenderContext: () => import("@/components/common/ScheduleCalendar/ScheduleCalenderContext"),
    ScheduleCalendarMobileContext: () => import("@/components/common/ScheduleCalendar/ScheduleCalendarMobileContext"),
  },
  props: {
    has_tickets: {
      type: Boolean,
      default: false,
    },
    id: {
      type: [Number, String],
      required: true,
    },
    entity: {
      type: String,
      required: true,
    },
    agency: {
      type: Object,
      default: () => null,
    },
    title: {
      type: String,
      default: () => '',
    },
    bookingTerms: {
      type: String,
      default: () => null,
    },
    cancellationTerms: {
      type: String,
      default: () => null,
    },
  },
  data() {
    return {
      width: null
    }
  },
  computed: {
    ...mapGetters({
      viewportWidth: 'viewport/width',
      data: 'schedule-calendar/data',
      days: 'schedule-calendar/days',
      pending: 'schedule-calendar/pending',
      currentDay: 'schedule-calendar/currentDay',
      currentMonth: 'schedule-calendar/currentMonth',
      filtersType: 'schedule-calendar/filtersType',
      logged: 'user/logged'
    }),
    style() {
      return {
        width: this.width + 'px'
      }
    }
  },
  watch: {
    viewportWidth() {
      this.$store.commit('schedule-calendar/setPending', true)
      setTimeout(() => {
        this.$store.commit('schedule-calendar/setPending', false)
      }, 1000)
    }
  },
  created() {
    if (!process.server) {
      this.$store.commit('schedule-calendar/reset')
    }
  },
  mounted() {
    this.$store.commit('schedule-calendar/setBookingTerms', this.bookingTerms)
    this.$store.commit('schedule-calendar/setCancellationTerms', this.cancellationTerms)
    this.$store.commit('schedule-calendar/setEntity', this.entity)
    this.$store.commit('schedule-calendar/setId', this.id)
    this.$store.commit('schedule-calendar/setAgency', this.agency)
    this.$store.commit('schedule-calendar/setTitle', this.title)
    this.$store.dispatch('schedule-calendar/fetch')
      .then(() => {
        if (this.$cookies.get('$openPopupOrder') && this.logged) {
          const options = this.$cookies.get('$openPopupOrder')
          this.$openPopupOrder(options)
          this.$cookies.remove('$openPopupOrder')
        }
        if (this.$cookies.get('$openPupUpForProtectedAreas') && this.logged) {
          const options = this.$cookies.get('$openPupUpForProtectedAreas')
          this.$openPupUpForProtectedAreas(options)
          this.$cookies.remove('$openPupUpForProtectedAreas')
        }
      });
  },
  methods: {
    changeWidth(width) {
      this.width = width
    }
  }
}
